export const formatNumber = (num) => num.toLocaleString("en-US");

export const getCurrencySymbol = (cur) => {
  if (cur === "INR") return "Rs.";
  return "$";
};

